import React from 'react';
import {Backdrop, CircularProgress} from '@mui/material';

type GlobalLoaderBackdropProps = {
  open: boolean;
};

const GlobalLoaderBackdrop: React.FC<GlobalLoaderBackdropProps> = ({open}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme: any) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(0,0,0,0.35)',
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalLoaderBackdrop;
